import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';
import { NavigationProgress, nprogress } from '@mantine/nprogress';
import useHeaderStore from '@/store/header';
import { useSearchParams } from '@/hooks/useCustomSearchParams';
import { GiftsModule } from '@/enums';

const EXCLUDED_ROUTES = new Set(['/sign-in', '/404', '/sign-out']);

export default function RouterTransition() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const previousPath = useRef<string>(`${pathname}?${searchParams?.toString()}`);
  const setRouterState = useHeaderStore((state) => state.setRouterState);
  const openNavPanel = useHeaderStore((state) => state.openNavPanel);

  useEffect(() => {
    const currentPath = `${pathname}?${searchParams?.toString()}`;
    if (currentPath !== previousPath.current) {
      nprogress.set(75);
      nprogress.start();
    }

    if (!EXCLUDED_ROUTES.has(pathname)) {
      //NOTE: this part includes custom gift's type as params
      //      which is crucial for custom product fetching for that flow. (custom-gift/page.tsx)
      if (pathname?.toLowerCase()?.includes(GiftsModule.customGift)) {
        const type = searchParams?.get('type');

        if (type) {
          setRouterState(pathname + '?type=' + type);
        }
      } else {
        setRouterState(pathname);
      }
    }

    const timeoutId = setTimeout(() => {
      nprogress.complete();
      openNavPanel(false);
    }, 75);

    previousPath.current = currentPath;
    return () => clearTimeout(timeoutId);
  }, [pathname, searchParams, setRouterState, openNavPanel]);

  return <NavigationProgress color="#E1252A" size={5} />;
}
